<template>
    <label class="inline-flex items-center">
        <input type="checkbox" :disabled="disabled" :name="name" :value="value" v-model="proxyChecked"
               :style="{ 'opacity': disabled ? 0.5 : 1 }"
               class="text-dark form-checkbox w-4 h-4 border-dark rounded-sm focus:outline-none focus:shadow-outline-white">
        <span class="ml-2.5"><slot></slot></span>
    </label>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    emits: ['update:checked'],

    props: {
        checked: {
            type: [Array, Boolean],
            default: false,
        },
        value: {
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
    },
})
</script>
